import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BasicTextInputComponent } from '../../form/base-components/base-text-input/basic-text-input.component';
import { AmorphicService } from '../../../services/amorphic/amorphic.service';
import { BaseLoginService } from '../../../services/login/base-login.service';
import { ValidationService } from '../../../services/validation/validation.service';
import { Auth0Controller } from '../../../../../common/js/authentication/Auth0Controller';
import { AuthenticationService } from '../../../services/authentication/authentication.service';

@Component({
  moduleId: module.id,
  selector: 'base-reset-password',
  templateUrl: './base-reset-password.component.html',
})
export class BaseResetPasswordComponent implements OnInit {
  @ViewChild('resetEmail') resetEmailInput: BasicTextInputComponent;
  @ViewChild('resetPassword') resetPasswordInput: BasicTextInputComponent;
  @ViewChild('resetConfirmPassword') resetConfirmPasswordInput: BasicTextInputComponent;
  errorMessage: string;
  controller;
  finishReset: boolean;
  emailSent: boolean;
  resetButtonDisabled: boolean;
  finishResetButtonDisabled: boolean;

  constructor(
    private amorphicService: AmorphicService,
    private validationService: ValidationService,
    private loginService: BaseLoginService,
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthenticationService
  ) {
    this.controller = amorphicService.controller;
  }

  ngOnInit(): void {
    this.finishReset = this.route.snapshot.queryParams['reset_password'] === 'true';
    this.resetButtonDisabled = this.controller.email ? false : true;
    this.finishResetButtonDisabled = true;
  }

  resetPassword(): void {
    if (!this.validateEmail()) {
      return;
    }

    this.loginService.resetPassword(document.location.href).then(() => {
      this.emailSent = true;
    });
  }

  finishResetPassword(): void {
    if (!this.validateFinishReset()) {
      return;
    }

    this.loginService
      .finishResetPassword()
      .then(async () => {
        const controller: Auth0Controller = this.controller as Auth0Controller;
        if (controller.isAuth0Enabled) {
          await controller.serverLogout();
          await this.authService.goToLogin();
        } else {
          this.router.navigate(['application-form']);
        }
      })
      .catch((error) => {
        this.errorMessage = 'Error resetting password';
      });
  }

  validateEmail(): boolean {
    if (this.resetEmailInput.val && !this.resetEmailInput.isError) {
      this.resetButtonDisabled = false;
      return true;
    } else {
      this.resetButtonDisabled = true;
      return false;
    }
  }

  validateFinishReset(): boolean {
    this.errorMessage = '';

    if (
      this.resetPasswordInput.val &&
      !this.resetPasswordInput.isError &&
      this.resetConfirmPasswordInput.val &&
      !this.resetConfirmPasswordInput.isError
    ) {
      if (this.resetPasswordInput.val !== this.resetConfirmPasswordInput.val) {
        this.resetConfirmPasswordInput.isError = true;
        this.errorMessage = 'Passwords do not match.';
      } else {
        this.finishResetButtonDisabled = false;
        return true;
      }
    } else {
      this.finishResetButtonDisabled = true;
      return false;
    }
  }
}
